// Friday, September 18 at 3 PM EDT. Keep labels and positioning aligned.
export const SCHEDULE_START = "2026-09-18T19:00:00Z";
export const SCHEDULE_END = "2026-09-20T04:00:00Z";
export const SCHEDULE_END_BUFFER = "2026-09-21T00:00:00Z";

export const getScheduleOffset = (date: Date) =>
  Math.round(
    ((date.getTime() - new Date(SCHEDULE_START).getTime()) * 128) / 3600000
  );

export const CUSTOM_EVENT_TYPES = ["ceremonies", "registration"];

export const SATURDAY_OFFSET = getScheduleOffset(
  new Date("2026-09-19T04:00:00Z")
);
export const SUNDAY_OFFSET = getScheduleOffset(new Date(SCHEDULE_END));
